
export class Sms {

	uniqueNumer: number;
	type: number;
	size: number;
	lastDigits: string;
	message: string;

	constructor() {}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-digital-signature/model/sms.ts